import { render } from "./AppToast.vue?vue&type=template&id=c873339a"
import script from "./AppToast.vue?vue&type=script&lang=js"
export * from "./AppToast.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__